export const appPageTransition = {"name":"fade","mode":"out-in"}

export const appHead = {"meta":[{"name":"viewport","content":"width=device-width, initial-scale=1"},{"charset":"utf-8"},{"name":"keywords","content":"Mathéo Galuba, Portfolio, Work, Software, Engineer, Developer, Web Developer, Frontend, Fullstack, Nuxt, Vue, JavaScript, TypeScript, TailwindCSS, HTML, CSS, SASS, SCSS, Git, GitHub, Discord, Figma, Photoshop, Illustrator, InDesign, Premiere Pro, After Effects, Audition, Lightroom, Blender, Unity, Unreal Engine, C#, C++, Python, Java, Kotlin, Swift, Dart, Flutter, React, Angular, Svelte, Node.js, Express, MongoDB, MySQL, PostgreSQL, Firebase, AWS, Azure, Google Cloud, Netlify, Vercel, DigitalOcean, PayPal, SendGrid, GraphQL, REST, API, SPA, PWA, SSR, SEO, UX, UI, A11Y"},{"name":"author","content":"Mathéo Galuba"},{"name":"description","content":"Mathéo Galuba's portfolio, showcasing his work as a software engineer and developer."},{"name":"application-name","content":"Portfolio - Mathéo Galuba"},{"name":"msapplication-TileColor","content":"#0c0816"},{"name":"theme-color","content":"#0c0816"},{"property":"og:url","content":"https://matheo-galuba.com"},{"property":"og:type","content":"website"},{"property":"og:title","content":"Portfolio - Mathéo Galuba"},{"property":"og:description","content":"Mathéo Galuba's portfolio, showcasing his work as a software engineer and developer."},{"property":"og:image","content":"https://matheo-galuba.com/og-image.png"},{"name":"twitter:card","content":"summary_large_image"},{"name":"twitter:title","content":"Portfolio - Mathéo Galuba"},{"name":"twitter:description","content":"Mathéo Galuba's portfolio, showcasing his work as a software engineer and developer."},{"name":"twitter:image","content":"https://matheo-galuba.com/og-image.png"}],"link":[{"rel":"apple-touch-icon","sizes":"180x180","href":"/apple-touch-icon.png"},{"rel":"icon","type":"image/png","sizes":"32x32","href":"/favicon-32x32.png"},{"rel":"icon","type":"image/png","sizes":"16x16","href":"/favicon-16x16.png"},{"rel":"manifest","href":"/site.webmanifest"},{"rel":"mask-icon","href":"/safari-pinned-tab.svg","color":"#0c0816"}],"style":[],"script":[{"src":"https://analytics.matheo-galuba.com/script.js","defer":true,"async":true,"data-website-id":"a0c61e3e-7dda-4e4d-9c5a-d376a12f9280"}],"noscript":[],"title":"Portfolio - Mathéo Galuba","charset":"utf-8","viewport":"width=device-width, initial-scale=1"}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const appSpaLoaderTag = "div"

export const appSpaLoaderAttrs = {"id":"__nuxt-loader"}

export const renderJsonPayloads = true

export const componentIslands = false

export const runtimeCompiler = false

export const payloadExtraction = true

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"value":null,"errorValue":null,"deep":true}

export const resetAsyncDataToUndefined = true

export const nuxtDefaultErrorValue = null

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"

export const crawlLinks = true

export const spaLoadingTemplateOutside = false

export const purgeCachedData = true

export const granularCachedData = false

export const pendingWhenIdle = true

export const alwaysRunFetchOnKeyChange = true